/**
 * Customize to adjust styles on kit widget
 */

import { TableCellResponsiveContent } from '@/components/blocks/Table/TableCellResponsiveContent';
import {
	kitTableItemQuantityLabelSX,
	kitTableItemQuantitySX,
} from '@/components/content/Kit/styles/Table/Quantity';
import { useLocalization } from '@/data/Localization';
import { KitTableData } from '@/data/types/Product';
import { Stack, Typography } from '@mui/material';
import { CellContext } from '@tanstack/react-table';
import { FC } from 'react';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const KitTableQuantity: FC<CellContext<KitTableData, number>> = ({ getValue }) => {
	const { Quantity } = useLocalization('HDMProductDetail');
	return (
		<TableCellResponsiveContent>
			<Stack alignItems="center" sx={kitTableItemQuantitySX}>
				<Typography variant="bodyCaption" sx={kitTableItemQuantityLabelSX}>
					{Quantity.t()}
				</Typography>
				<Typography variant="bodyBaseline" fontWeight={OpenSansFontWeights.semibold}>
					{getValue() ?? 0}
				</Typography>
			</Stack>
		</TableCellResponsiveContent>
	);
};
